/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { Snackbar, Link, Alert, SnackbarOrigin, AlertColor, SnackbarCloseReason } from '@mui/material';
import { Logger } from '../../../libs/utils/logger';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/downloadicon.svg';

Logger.debug("FxSnackBarView.tsx", "Fx Snack Bar initializing")

export type FxSnackBarViewProps = {
    open: boolean;
    /**
     * @default 6000
     */
    autoHideDuration: number;
    anchorOrigin: SnackbarOrigin;
    /**
     * @default 'error'
     */
    severity: AlertColor;
    text: string | string[];
    url?: string;
    linkText?: string;
    onClose: (event: React.SyntheticEvent<any> | Event, reason?: SnackbarCloseReason) => void;
    icon?:any,
    isBulkDownload?:boolean
}

export const FxSnackBarView: React.FC<FxSnackBarViewProps> = (props) => {
    // Final message generation from text
    const finalMessage = useMemo(() => {
        if(typeof props.text === 'string') {
            return props.text;
        }
        return props.text?.map((message) => (
            <>
                {message}
                <br/>
            </>
        ));
    }, [props.text]);

    /**
     * Memoized function to get the icon.
     * - If `props.icon` is provided, it returns the icon.
     * - Otherwise, it returns null.
     * - Recalculates only when `props.icon` changes.
     */
    const getIcon = useMemo(() => {
        if (props.icon) return props.icon; 
        return null;
    }, [props.icon]); 
    

    return (
        <Snackbar id='snack-bar'
            open={props.open}
            autoHideDuration={props.autoHideDuration}
            onClose={props.onClose}
            anchorOrigin={props.anchorOrigin}>
            <Alert severity={props.severity}
                icon={props?.isBulkDownload && <DownloadIcon/>}
                className={props?.severity === 'info' ? 'fx-info-severity' : props?.severity === 'warning' ? "fx-warning-severity" : ''}
                variant={'filled'}
                onClose={props.onClose}
                action={
                    (props.linkText && props.url) && <Link href={props.url}  >
                        {props.linkText}
                    </Link>
                }>
                <div>
                    {finalMessage}
                </div>
            </Alert>
        </Snackbar>
    );
}
